import { OnChanges, Component, Input, OnInit } from '@angular/core';
import { RenaultMyServiceActionDTO, RenaultMyServiceActionResultUser } from 'src/app/models/renault-myservice-dto';

@Component({
  selector: 'my-service-action-result-user',
  templateUrl: './my-service-action-result-user.component.html',
  styleUrls: ['./my-service-action-result-user.component.scss']
})
export class MyServiceActionResultUserComponent implements OnInit {

  @Input() modelResult: RenaultMyServiceActionResultUser[];


  constructor() { }

  ngOnInit() {    
    
  }

 
}
